module.exports = __webpack_public_path__ + "img/vub-isg.e73d5ef7.svg";